import type { InputHTMLAttributes } from "react";
import PhoneInput from "react-phone-number-input";
import "react-phone-number-input/style.css";
import { phoneDefaultCountry } from "@/lib/phone";

export interface PhoneInputFieldProps {
  value: string;
  onChange: (value: string) => void;
  defaultCountry?: string;
  wrapperClassName?: string;
  inputClassName?: string;
  error?: string;
  id?: string;
  "data-testid"?: string;
  disabled?: boolean;
  placeholder?: string;
}

export function PhoneInputField({
  value,
  onChange,
  defaultCountry = "US",
  wrapperClassName = "phone-input-admin mt-1",
  inputClassName,
  error,
  id,
  "data-testid": testId,
  disabled,
  placeholder,
}: PhoneInputFieldProps) {
  const borderClass = error ? "border-red-500 focus-visible:ring-red-500" : "border-input";
  const defaultInputClass = `flex h-9 w-full rounded-md border ${borderClass} bg-background px-3 py-1 text-sm shadow-sm transition-colors placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50`;

  return (
    <>
      <PhoneInput
        international
        defaultCountry={phoneDefaultCountry(defaultCountry)}
        value={value || undefined}
        onChange={(val) => onChange(val || "")}
        className={wrapperClassName}
        numberInputProps={
          {
            id,
            inputMode: "tel" as const,
            autoComplete: "tel",
            placeholder,
            disabled,
            "data-testid": testId,
            className: inputClassName ?? defaultInputClass,
          } as InputHTMLAttributes<HTMLInputElement> & { "data-testid": string }
        }
      />
      {error && (
        <p className="text-xs text-destructive mt-1">{error}</p>
      )}
    </>
  );
}
